import React, { useContext, useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import "flatpickr/dist/themes/material_blue.css";
import { ConfigContext } from "../../Context/ConfigContext";
import StatusChart from "./StatusChart";
import DonutChart from "./DonutCharts";
import axios from "axios";

const Dashboard = () => {
  const { apiURL, apiHeaderJson, user_profile_id } = useContext(ConfigContext);

  const [loading, setLoading] = useState(false)
  const [data, setData] = useState({})
  const [totalProjects, setTotalProjects] = useState([])
  const [projects, setProjects] = useState([])

  const getDashboardData = async () => {
    try {
      setLoading(true)
      const headers = apiHeaderJson
      const response = await axios.get(`${apiURL}api/GetDashboardForClient`, {
        headers,
        params: { client_id: user_profile_id }
      })
      const { success, data } = response.data

      if (success) {
        setData(data?.tabs)
        setProjects(data?.tabs)
        setTotalProjects(data?.tabs?.total_projects)
      } else {
        setData({})
      }
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getDashboardData()
  }, [user_profile_id])


  const cards = [
    {
      title: "Total Projects",
      value: data?.total_projects?.length || 0,
      linkText: "View All Projects",
      link: "/ProjectList",
      iconClass: "ri-building-2-line",
      iconBg: "bg-info-subtle",
      iconColor: "text-info",
    },
    {
      title: "Completed Projects",
      value: data?.total_completed_projects?.length || 0,
      linkText: "See All Completed Projects",
      link: "/ProjectList/1",
      iconClass: "ri-checkbox-circle-line",
      iconBg: "bg-success-subtle",
      iconColor: "text-success",
    },
    {
      title: "Cancelled Projects",
      value: data?.projects_with_issue?.length || 0,
      linkText: "View cancelled Projects",
      link: "/ProjectList/2",
      iconClass: "ri-close-circle-line",
      iconBg: "bg-danger-subtle",
      iconColor: "text-danger",
    },
    {
      title: "Pending Projects",
      value: data?.total_pending_projects?.length || 0,
      linkText: "See All Pending Projects",
      link: "/ProjectList/0",
      iconClass: "bx bx-hourglass",
      iconBg: "bg-warning-subtle",
      iconColor: "text-warning",
    },
  ];

  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <div className="row mb-3 pb-1">
            <div className="col-lg-12">
              <div className="d-flex align-items-lg-center flex-lg-row flex-column">
                <div className="flex-grow-1">
                  <h4 className="fs-16 mb-1">Good Morning, Client !</h4>
                  <p className="text-muted mb-0">
                    Here's what's happening with your store today.
                  </p>
                </div>
                <div className="mt-3 mt-lg-0">
                  <NavLink
                    to={"/ProjectList"}
                    className="btn btn-soft-info btn-sm"
                  >
                    <i className="ri-eye-line align-middle me-1" />
                    Project List
                  </NavLink>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            {cards.map((card, index) => (
              <div key={index} className="col-xl-3 col-md-6">
                <div className="card card-animate">
                  <div className="card-body">
                    <div className="d-flex align-items-center">
                      <div className="flex-grow-1">
                        <p className="text-uppercase fw-medium text-muted mb-0">
                          {card.title}
                        </p>
                      </div>
                    </div>

                    <div className="d-flex align-items-end justify-content-between mt-4">
                      <div>
                        <h4 className="fs-22 fw-semibold ff-secondary mb-4">
                          {card.value}
                        </h4>
                        <Link
                          to={card.link}
                          className="text-decoration-underline text-muted"
                        >
                          {card.linkText}
                        </Link>
                      </div>

                      <div className="avatar-sm">
                        <span
                          className={`avatar-title ${card.iconBg} rounded fs-3`}
                        >
                          <i
                            className={`${card.iconClass} ${card.iconColor}`}
                          />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="row">
            <div className="col-xl-7">
              <div className="card">
                <StatusChart projects={projects} />
              </div>
            </div>

            <div className="col-xl-5">
              <div className="card">
                <DonutChart totalProjects={totalProjects} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
